<template>
  <div>
    <CustomModal :title="`${tipoCusta === 'REGISTRO_CIVIL' ? 'Custa personalizada de Registro Civil': 'Custa personalizada de Atos Notariais'}`"
                 :show="show"
                 size="xl"
                 :title-button="!!form.custa_id ? 'Salvar' : 'Criar Custa'"
                 :disabled-button="!!(form.custa_id && form.registro_oficial)"
                 @closeModal="closeModal"
                 @ok="() => form.custa_id ? update() : salvar()">
      <div class="d-flex align-items-center justify-content-between ml-2">
        <CustomInput
          class="col-4"
          name="ato"
          label="Nome"
          :required="true"
          :form-erros="formErros"
          :initial-value="form.ato"
          :disabled="!!form.registro_oficial"
          type="text"
          @setError="setError"
          @blur="setValueInput" />

        <custom-input
          class="col-4"
          name="descricao_simplificada_ato"
          label="Descrição"
          type="text"
          :disabled="!!form.registro_oficial"
          :initial-value="form.descricao_simplificada_ato"
          @blur="setValueInput" />

        <b-form-checkbox
          v-model="form.livro_caixa"
          v-validate="'required'"
          :disabled="!!form.registro_oficial"
          name="custa_livro_caixa"
          switch
          @change="setFlag(form.livro_caixa, 'livro_caixa')">
          Livro-Caixa
        </b-form-checkbox>

        <b-form-checkbox id="custa_recolhimento"
                         v-model="form.recolhimento"
                         :disabled="!!form.registro_oficial"
                         name="custa_recolhimento"
                         switch
                         @change="setFlag(form.recolhimento, 'recolhimento')">
          Recolhimento
        </b-form-checkbox>
      </div>
      <div class="m-5" />
      <div class="mb-5">
        <b-form-group class="m-3">
          <label for="campoObrigatorio" class="form-label">
            Tipo de registro<span class="text-danger">*</span>
          </label>
          <b-form-radio-group
            id="radio-group-1"
            v-model="form.tipo_registro"
            :disabled="!!form.registro_oficial"
            :options="optionsTipoRegistro"
            name="tipos-registro" />
        </b-form-group>
      </div>

      <div class="d-flex align-items-center mt-4">
        <CustomSelect class="col-6"
                      name="selo_digital"
                      :options="computedAtos"
                      :label="'Selo Digital'"
                      :selected="form.tipo_ato"
                      :disabled="!!form.registro_oficial || !form.tipo_registro"
                      :max-height-display="200"
                      @setSelectValue="(ev) => setAto(ev)" />
        <CustomSelect class="col-6"
                      name="impresso_seguranca"
                      :options="computedPapeis"
                      :label="'Impresso Segurança'"
                      :selected="form.impresso_seguranca"
                      :disabled="!!form.registro_oficial"
                      :max-height-display="200"
                      @setSelectValue="(ev) => setPapel(ev)" />
      </div>

      <div>
        <div v-if="custa"
             class="d-flex flex-wrap align-items-center mt-4">
          <div v-for="item of form.itens"
               :key="item.custa_item_id"
               class="col-2">
            <CustomInput
              class="mt-3"
              :name="item.destino"
              :label="item.destino"
              :prop-money="true"
              :initial-value="item.valor"
              :form-erros="formErros"
              validate-type="dinheiro"
              :disabled="!!form.registro_oficial"
              type="text"
              @blur="setDestinatario" />
          </div>
        </div>

        <div v-if="!custa"
             class="d-flex flex-wrap align-items-center mt-4">
          <div v-for="item of form.itens"
               :key="item.destino"
               class="col-2">
            <CustomInput
              class="mt-3"
              :name="item.destino"
              :label="item.destino"
              :prop-money="true"
              :initial-value="item.valor | moneyToString"
              :form-erros="formErros"
              validate-type="dinheiro"
              :disabled="!!form.registro_oficial"
              type="text"
              @setError="setError"
              @blur="setDestinatario" />
          </div>
        </div>
      </div>

      <div class="col-12 mt-5">
        <div class="row">
          <div class="col" />
          <div class="col d-flex justify-content-between custas_total p-2 mr-3">
            <h5>Total</h5>
            <div>{{ computedTotalView | moneyToString }}</div>
          </div>
        </div>
      </div>
    </Custommodal>
  </div>
</template>

<script>
  // Componentes
  import CustomInput from "@/components/CustomInputs/CustomInput"
  import CustomSelect from "@/components/CustomInputs/CustomSelect"
  import CustomModal from "@/components/CustomModal/CustomModal"

  // Entities
  import Custa from '@/entities/Custas/Custa.js'

  // Constants
  import { getAtos, getAtosByCodigoCusta } from '@/constants/atosCustas'
  import { optionsRegistro } from '@/constants/custas'
  import { optionsRegistro as optionsRegistroCivil, optionsRegistroAtosNotariais } from '@/constants/custas'

  // services
  import CustasService from '@/services/Registros/CustasService'
  import PapelSegurancaLoteService from '@/services/PapelSeguranca/PapelSegurancaLoteService'

  // others
  import { mapGetters } from "vuex"
  import moment from 'moment'

  export default {
    name: "CustaModal",
    components: {
      CustomModal,
      CustomSelect,
      CustomInput
    },
    props: {
      show: { type: Boolean, default: false },
      tipoCusta: { type: String, default: 'REGISTRO_CIVIL' },
      custa: { type: Object, default: null },
      vigencia: { type: String, default: null },
    },
    data () {
      return {
        tiposAtos: [],
        tiposPapeis: [],
        form: new Custa(),
        formErros: [],
        optionsTipoRegistro: optionsRegistroCivil,
        atosNotariaisValues: ['escrituras', 'procuracao', 'autenticacao', 'firmas', 'testamentos'],
        destinatarios: [
          { key: 'AO OFICIAL', label: 'Ao Oficial', tipo: 'REGISTRO_CIVIL', valor: 0 },
          { key: 'ISS', label: 'ISS', tipo: 'REGISTRO_CIVIL', valor: 0 },
          { key: 'A SEC. FAZ.', label: 'Sec. da Fazenda', tipo: 'REGISTRO_CIVIL', valor: 0 },
          { key: 'SANTA CASA', label: 'Sta. Casa', tipo: 'FIRMA', valor: 0 },
          { key: 'ESTADO', label: 'Estado', tipo: 'FIRMA', valor: 0 },
          { key: 'MUNICIPIO', label: 'Município', tipo: 'FIRMA', valor: 0 },
          { key: 'REGISTRO CIVIL', label: 'Reg. Civil', tipo: 'FIRMA', valor: 0 },
          { key: 'MINISTERIO PUBLICO', label: 'Min. Público', tipo: 'FIRMA', valor: 0 },
          { key: 'TRIBUNAL JUSTICA', label: 'Trib. Just.', tipo: 'FIRMA', valor: 0 },
          { key: 'TABELIAO', label: 'Tabelião', tipo: 'FIRMA', valor: 0 },
          { key: 'A SEC. FAZ', label: 'Sec. da Fazenda', tipo: 'FIRMA', valor: 0 },
        ]
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj'
      }),
      computedAtos () {
        return getAtos()
          .filter(item => item.tipo_registro === this.form.tipo_registro)
          .map(ato => ({ text: `${ato.codigo}: ${ato.descricao}`, value: ato.codigo }))
      },
      computedPapeis () {
        return this.tiposPapeis.map(papel => ({ text: papel.label, value: papel.value }))
      },
      computedDestinatarios () {
        return this.destinatarios.filter(dest => dest.tipo === this.tipoCusta)
      },
      computedTotalView () {
        let total = 0
        for (const item of this.form.itens) {
          const valorNumerico = this.toNumberMoney(item.valor)
          total += valorNumerico
        }
        return total
      },
    },
    watch: {
      custa () {
        this.handlerCusta()
      },
      async vigencia () {
        this.handlerCusta()
      },
      show () {
        this.handlerCusta()
      },
      tipoCusta (newValue) {
        this.optionsTipoRegistro = newValue === 'REGISTRO_CIVIL' ? optionsRegistroCivil : optionsRegistroAtosNotariais
      }
    },
    async created () {
      // Lida com tipos de impressos
      const listTiposResponse = await PapelSegurancaLoteService.listTipos()
      const array = [...listTiposResponse.tipos_de_papeis, ...listTiposResponse.tipos_de_selos]
      this.tiposPapeis = array

      // Verifica se custa foi enviado ou se iremos criar uma nova
      this.handlerCusta()
    },
    methods: {
      handlerCloseModal () {},
      toNumberMoney (value) {
        if (value === null || value === undefined) return 0
        if (typeof value === 'number') return Number.isFinite(value) ? Math.trunc(value) : 0

        const str = String(value)
          .replace(/\u00A0/g, ' ') // nbsp
          .trim()

        if (!str) return 0
        if (/nan/i.test(str)) return 0

        const onlyDigits = str.replace(/[^\d]/g, '')
        if (!onlyDigits) return 0

        const n = Number(onlyDigits)
        return Number.isFinite(n) ? n : 0
      },

      sanitizeValoresItens () {
        if (!this.form || !Array.isArray(this.form.itens)) return
        this.form.itens = this.form.itens.map((it) => ({
          ...it,
          valor: this.toNumberMoney(it.valor)
        }))
      },

      async salvar () {
        if (this.formErros.length > 0 || !this.form.tipo_registro) {
          return displayMessage('error', 'Error!', 'Preencha todos os campos obrigatórios!')
        }

        try {
          loader({active: true, text: "Criando custa..."})
          this.handleTipoRegistro()

          this.sanitizeValoresItens()

          await CustasService.storeCustas(this.form)
          displayMessage('success', 'Success', 'Custa criada com sucesso!')
          this.$emit('atualizarLista')
        } catch (error) {
          const message = error.message
          displayMessage('error', 'Error!', 'Erro ao criar custa')
        } finally {
          loader({active: false, text: ""})
          this.closeModal()
        }
      },

      async update () {
        try {
          loader({active: true, text: "Criando custa..."})
          this.handleTipoRegistro()

          this.sanitizeValoresItens()

          await CustasService.updateCustas(this.form, this.form.custa_id)
          displayMessage('success', 'Success', 'Custa atualizada com sucesso!')
          this.$emit('atualizarLista')
        } catch (error) {
          const message = error.message
          displayMessage('error', 'Error!', 'Erro ao atualizar custa')
        } finally {
          loader({active: false, text: ""})
          this.closeModal()
        }
      },

      handlerCusta () {
        if (this.custa) {
          this.form = new Custa(this.custa)
          this.form.recolhimento = this.custa.recolhimento == 1 ? true : false
          this.form.livro_caixa = this.custa.livro_caixa == 1 ? true : false

          if (!this.form.registro_oficial) {
            this.form.impresso_seguranca = this.custa.tipo_impresso_seguranca_personalizado
              ? this.custa.tipo_impresso_seguranca_personalizado
              : this.custa.impresso_seguranca
          }

          this.sanitizeValoresItens()
        } else {
          this.form = new Custa({
            vigencia: moment(this.vigencia, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            tipo: this.tipoCusta === 'REGISTRO_CIVIL' ? this.tipoCusta : 'FIRMA',
            ativo: 1,
            cartorio_id: this.cartorioObj.cartorio_id,
            registro_oficial: 0
          })

          // Cria estrutura de destinatarios para nova custa
          this.form.criaEstruturaDestinatarios(this.computedDestinatarios)

          this.sanitizeValoresItens()
        }
      },

      setValueInput (nome, value) {
        this.form[nome] = value
      },

      setDestinatario (nome, value) {
        const valorSeguro = this.toNumberMoney(value)
        this.form.atualizaValorDestino(nome, valorSeguro)
      },

      setError (newArray) {
        this.formErros = newArray
      },

      setAto (ev) {
        this.form.tipo_ato = ev.value
      },

      setPapel (ev) {
        this.form.impresso_seguranca = ev.value
        if (!this.form.registro_oficial) {
          this.form.tipo_impresso_seguranca_personalizado = this.form.impresso_seguranca
        }
      },

      closeModal () {
        this.form = new Custa()
        this.$emit('onCalcel')
      },

      handleTipoRegistro () {
        if (this.atosNotariaisValues.includes(this.form.tipo_registro)) this.form.tipo_registro = 'todos'
      },

      setFlag (value, type) {
        if (type == 'recolhimento') {
          this.form.recolhimento = value
        } else {
          this.form.livro_caixa = value
        }
      }
    }
  }
</script>
